import { z } from "zod";
import { email, flag, id } from "./common";

export const memberRole = z.enum(["owner", "admin", "member"]);
export type MemberRole = z.infer<typeof memberRole>;

export const memberInvite = z.object({
  email,
  name: z.string().trim().min(1).max(120),
  role: memberRole.default("member"),
  phone: z.string().trim().max(40).nullable().optional(),
  title: z.string().trim().max(120).nullable().optional(),
});
export type MemberInvite = z.infer<typeof memberInvite>;

export const memberPatch = z.object({
  role: memberRole.optional(),
  active: flag.optional(),
  title: z.string().trim().max(120).nullable().optional(),
  phone: z.string().trim().max(40).nullable().optional(),
  smsNotify: flag.optional(),
  emailNotify: flag.optional(),
  allVenues: flag.optional(),
  venueIds: z.array(id).optional(),
  name: z.string().trim().min(1).max(120).optional(),
});
export type MemberPatch = z.infer<typeof memberPatch>;
